import cloneDeep from 'lodash/cloneDeep'

const deleteNewItem = (currentPointList, data) => {
  const cloneCurrentPointList = cloneDeep(currentPointList)
  const filteredItem = cloneCurrentPointList.filter(item => {
    // 既存のアイテムは関係ないのでそのまま返す
    if (item.newItem.new === false) {
      return true
    }
    // newItem.id が一致するもののみ返さない
    return item.newItem.id !== data.newItem.id
  })
  return filteredItem
}

export default deleteNewItem
